// "country_code"というname属性を持つ要素を取得
var slc_elements = document.getElementsByName("country_code");

// 全ての該当要素にイベントリスナーを登録
Array.from(slc_elements).forEach(function (element) {
  // focusイベント
  element.addEventListener("focus", function (e) {
    if (e.currentTarget.options.length >= 11) {
      e.currentTarget.size = "10";
    }
  });

  // blurイベント
  element.addEventListener("blur", function (e) {
    e.currentTarget.size = "1";
  });

  // changeイベント
  element.addEventListener("change", function (e) {
    e.currentTarget.blur();
  });
});
